<script>
export default {
  components: {},
  props: {
    minimal: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
    content: {
      type: [String, Number],
      required: false,
      default: null,
    },
    noBorder: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <span
    :class="[
      'notification-bubble',
      { minimal: minimal, 'no-border': noBorder },
    ]"
  >
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'notification-icon'" v-bind:svg-inline="''" v-if="!minimal && type === 'message'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75.85V8.5c0 .467-.383.85-.85.85H3.4L0 12.75V.85C0 .383.383 0 .85 0H11.9c.467 0 .85.383.85.85zm1.7 2.55h1.7c.468 0 .85.383.85.85V17l-3.4-3.4H4.25a.852.852 0 01-.85-.85v-1.7h11.05V3.4z" fill="#000"/></svg>
    <span class="count" v-if="!minimal && type === 'count'">{{ content }}</span>
  </span>
</template>

<style lang="scss" scoped>
@import '@design';

.notification-bubble {
  align-items: center;
  background-color: $color-notification;
  border-radius: 50%;
  display: flex;
  height: 2.4rem;
  justify-content: center;
  left: 5.1rem;
  position: absolute;
  top: -0.6rem;
  width: 2.4rem;

  &.message {
    background-color: $color-red;
  }

  .notification-icon {
    height: 1.2rem;
    width: 1.2rem;

    path {
      fill: white;
    }
  }

  .count {
    color: white;
    font-size: 1rem;
    font-weight: 900;
    letter-spacing: 0.25px;
    line-height: 0.9rem;
  }

  &.minimal {
    border: 2px solid $color-off-white;
    height: 1rem;
    left: 1.2rem;
    top: -0.2rem;
    width: 1rem;

    &.no-border {
      border: 0;
      height: 0.6rem;
      width: 0.6rem;
    }
  }
}
</style>
